jQuery(function ($) {
	const { jsPDF } = window.jspdf;
	Date.prototype.addDays = function (days) { //2018, and still date handling in JS is a crime against programming...
		var date = new Date(this.valueOf());
		date.setDate(date.getDate() + days);
		return date;
	}

	var calendar;
	if (localStorage.getItem('cardio_calendar')) {
		calendar = JSON.parse(localStorage.getItem('cardio_calendar'));
		if (new Date(calendar.dtStart).addDays(37) < new Date()) {
			//It's been more than five weeks (plus some margin for lateness) since this session first started, so clear the data
			localStorage.removeItem('cardio_calendar');
			calendar = { dtStart: new Date().toISOString() };
		} else {
			$('#dtElkonvertering').val(calendar.dtElkonvertering);
			$('#tmElkonvertering').val(calendar.tmElkonvertering);
			$('#place').val(calendar.place);
			$('#nurse').val(calendar.nurse);
			$('#phone').val(calendar.phone);
			$('#doctor').val(calendar.doctor);
			$('#other').val(calendar.other);
		}

	} else {
		calendar = { dtStart: new Date().toISOString() };
	}

	var saveValuesToLocalStorage = function () {
		var weeks = [];
		$('.cardioVersion__tableWrapper').each(function () {
			var week = [];
			$(this).find('tr').each(function (i) {
				if (i > 0) { //first row is just headings
					var $this = $(this);
					var day = {
						'datum': $this.find('input[name*="datum"]').val(),
						'morgon': $this.find('input[name*="morgon"]').prop('checked'),
						'kvall': $this.find('input[name*="kvall"]').prop('checked'),
						'notes': $this.find('textarea[name*="notes"]').val()
					}
					week.push(day);
				}
			});
			weeks.push(week);
		});
		calendar.weeks = weeks;

		calendar.dtElkonvertering = $('#dtElkonvertering').val();
		calendar.tmElkonvertering = $('#tmElkonvertering').val();
		calendar.place = $('#place').val();
		calendar.nurse = $('#nurse').val();
		calendar.phone = $('#phone').val();
		calendar.doctor = $('#doctor').val();
		calendar.other = $('#other').val();

		localStorage.setItem('cardio_calendar', JSON.stringify(calendar));
	}


	$('.cardioVersion').on('change', 'input,textarea', function () {
		//if this sets the date for day one in a week, make the others follow naturally from there
		var $this = $(this);
		if ($this.attr('type') === 'date' && $this.closest('tr').index() === 1) {
			var dtDate = new Date($this.val());
			$this.closest('table').find('input[type=date]').each(function (i) {
				if (i > 0) {
					dtDate = dtDate.addDays(1);
					$(this).val(dtDate.toISOString().substr(0, 10));
				}
			});
		}
		//Then, save everything
		saveValuesToLocalStorage();
	});

	var setValueFromLocalStorage = function ($this, i) {
		var nameParts = $this.attr('name').split('_');
		var week = calendar.weeks[i - 1];
		var index = parseInt(nameParts[1]);
		switch (nameParts[0]) {
			case 'datum':
				$this.val(week[index].datum);
				break;
			case 'morgon':
				$this.prop('checked', week[index].morgon);
				break;
			case 'kvall':
				$this.prop('checked', week[index].kvall);
				break;
			case 'notes':
				$this.val(week[index].notes);
		}
	}

	//First, create the 5 weeks from template
	var $table = $('.cardioVersion__tableWrapper');
	var $buttonDiv = $('.cardioVersion__buttons');

	for (var i = 2; i <= 5; i++) { //leave "first" week as is, but create four modified copies
		var $clone = $table.clone();
		$clone.find('input, textarea').each(function () {
			var $this = $(this);
			//fill the correct values as well, if they exist
			if (calendar.weeks) {
				setValueFromLocalStorage($this, i);
			}
			$this.attr('name', i + '_' + $this.attr('name')); //prepend week number

		});
		$clone.find('.js-weeknum').text(i);
		//show the last filled out week
		if (calendar.weeks && calendar.weeks[i - 1][0].datum && calendar.weeks[i - 1][0].datum.length === 10) {
			$('.cardioVersion__tableWrapper.active').removeClass('active');
			$clone.addClass('active');
		} else {
			$clone.removeClass('active');
		}
		$clone.insertBefore($buttonDiv);
	}
	if (calendar.weeks) { //also set the values for the first week
		$table.find('input, textarea').each(function () {
			setValueFromLocalStorage($(this), 1);
		});
	}
	//enable/disable the pagination buttons
	(function() {
		var $currEl = $('.cardioVersion__tableWrapper.active');
		if ($currEl.index() === 5) {
			$('.js-next-week').addClass('btn--disabled');
		} else if ($currEl.index() <= 1) {
			$('.js-prev-week').addClass('btn--disabled');
		}
	})();

	$('.js-next-week').on('click', function (e) {
		e.preventDefault();
		$('.js-prev-week').removeClass('btn--disabled');
		var $currEl = $('.cardioVersion__tableWrapper.active');
		if ($currEl.index() < 5) { //validate there is a next/prev to go to
			$currEl.removeClass('active').next().addClass('active');
		}
		if ($currEl.index() === 4) {
			$(this).addClass('btn--disabled');
		}
	});
	$('.js-prev-week').on('click', function (e) {
		e.preventDefault();
		$('.js-next-week').removeClass('btn--disabled');
		var $currEl = $('.cardioVersion__tableWrapper.active');
		if ($currEl.index() > 1) { //validate there is a next/prev to go to
			$currEl.removeClass('active').prev().addClass('active');
		}
		if ($currEl.index() <= 2) {
			$(this).addClass('btn--disabled');
		}
	});

	function getCanvas(args) {
		//Renders all of the days into a canvas
		return html2canvas(args.container, {
			imageTimeout: 0,
			removeContainer: true,
			logging: false,
			height: args.height || args.container.scrollHeight,
			windowHeight: args.height || args.container.scrollHeight,
			windowWidth: 768, //fixed to 768 to get a consistent look
			width:768,
			x:0,
			scrollY: 0,
			y:0,
			backgroundColor: null,
			ignoreElements: function(el) {
				//Ignore all elements that aren't to be rendered
				var nodeName = el.nodeName.toLowerCase();
				if(nodeName === 'section' && el.className.indexOf('components-cardio-conversion-calendar') == -1) {return true;}
				if(nodeName === 'header' || nodeName === 'footer' || nodeName === 'script') {return true;}
				if(nodeName === 'div' && (el.id === 'consent_blackbar' || el.id === 'sprite-plyr' || el.className.indexOf('components-globals-page-navigation') > -1 || el.className.indexOf('pulseCalendar__buttons') > -1)) {return true;}
				if(args.ignoreEl) { return args.ignoreEl(el);}
			},
			onclone: function(clonedDoc) {
				var $main = $(clonedDoc.getElementsByTagName('main'));
				$main.find('section').removeClass('px-1');
				$main.removeClass('mt-1 lg:mt-5').css({
					'padding': '0px'
				});
				$main.children().removeClass('-mx-1');
				$main.find('.mt-2.mb-4').removeClass('mt-2 mb-4');
				$main.find('.cardioVersion').addClass('printing');
				//try to make pdf look nicer if page zoom is increased
				const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
				let scaleVal = 0;
				if(browserZoomLevel > 100) {
					scaleVal = 100 - (browserZoomLevel - 100);
					let scaleValues = {
						90: 110,
						110: 90,
						125: 78,
						150: 62,
						175: 56,
						200: 50
					};
					if($.browser.mozilla) {
						scaleValues = {
							109: 92,
							110: 92,
							120: 84,
							130: 78,
							140: 74,
							150: 68,
							158: 60,
							171: 45,
							182: 40,
							188: 35,
							200: 15
						};
					}
					$main.find('.cardioVersion').css({
						'scale': scaleValues[browserZoomLevel]+'%',
						'transform-origin': '0 0'
					});
				} else {
					$main.find('.cardioVersion').css({
						'scale': '100%',
						'transform-origin': '0 0'
					});
				}
				args.onClone($main);
			}
		});
	}

	$('.js-print-cardioconversion').on('click', function (e) {
		e.preventDefault();
		$('#pulse-print').remove();
		$('#cardio-print').remove();
		createCardioPDF(function(doc) {
			doc.autoPrint();
			const hiddenPdf = document.createElement('embed');
			hiddenPdf.style.position = 'fixed';
			hiddenPdf.style.width = '1px';
			hiddenPdf.style.height = '1px';
			hiddenPdf.style.opacity = '0.01';
			hiddenPdf.setAttribute("id", "cardio-print");
			hiddenPdf.setAttribute("type", "application/pdf");
			hiddenPdf.src = doc.output('bloburl');
			document.body.appendChild(hiddenPdf);
		});
	});
	//TODO: maybe add some loading indicator
	$('.js-download-cardioconversion').on('click', function (e) {
		e.preventDefault();
		$('#pulse-print').remove();
		$('#cardio-print').remove();
		createCardioPDF(function(doc) {
			doc.save('konverteringskalender.pdf');
		});
	});

	function createCardioPDF(callback) {
		var pdfDoc = new jsPDF({
			orientation: 'p',
			unit: 'pt',
			format: 'a4'
		});
		// render the "contact details" on the first page separately.
		var $infoDiv = $('.cardioVersion__information');
		getCanvas({
			container: $infoDiv[0],
			onClone: function($main) {
				$main.find('input').each(function () {
					var $this = $(this);
					var p = $(document.createElement('p')).text($this.val());
					$this.hide();
					p.insertAfter($this.parent());
					const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
					let scaling = {
						110: 120,
						120: 130,
						125: 150,
						130: 150,
						140: 160,
						150: 170,
						175: 210,
					};
					if(browserZoomLevel != 100 && scaling[browserZoomLevel]) {
						$main.find('.cardioVersion__information').css({
							'scale': scaling[browserZoomLevel]+'%',
							'transform-origin': '0 0'
						});
					} else if(browserZoomLevel < 100) {
						$main.find('.cardioVersion__information .flex .w-full').css({
							'width': '50%'
						});
					}
				});
			}
		}).then(function(canvas) {
			// window.open(canvas.toDataURL('image/png')); //for debugging only
			const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
			let scaleWidth = 545;
			let scaledWidth = {
				90: 630,
				80: 700,
			};
			if(browserZoomLevel < 100 && scaledWidth[browserZoomLevel]) {
				scaleWidth = scaledWidth[browserZoomLevel];
			}
			pdfDoc.addImage(canvas.toDataURL('image/png'), 'png', 0, 0, scaleWidth, Math.round(canvas.height * 545 / canvas.width) );
			renderWeeks(); //only start rest of render once this is complete, since this is all async
		});

		//then, render the weeks preferably all at the same time, then split them and fit into pages
		function renderWeeks() {
			const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
			var $cardioVersion = $('.cardioVersion');
			var tableSizes = [];
			getCanvas({
				container: $cardioVersion[0],
				height: $cardioVersion[0].scrollHeight * 5,
				ignoreEl: function(el) {
					if(el.className.indexOf('cardioVersion__information') > -1 || el.className.indexOf('cardioVersion__buttons') > -1) { return true;}
				},
				onClone: function($main) {
					$main.find('input[type=date]').each(function () {
						var $this = $(this);
						$this.replaceWith($(document.createElement('span')).text($this.val()));
					});
					$main.find('textarea').each(function () {
						var $this = $(this);
						$this.replaceWith($(document.createElement('span')).html($this.val().replace(/\n|\r/g, '<br/>')));
					});
					$main.find('input[type=checkbox]').each(function () {
						var $this = $(this);
						if ($this.prop('checked')) {
							$this.closest('.checkbox').replaceWith($(document.createElement('span')).text('Tagit'));
						} else {
							$this.closest('.checkbox').replaceWith($(document.createElement('span')).html('Ej&nbsp;tagit'));
						}
					});
					if(browserZoomLevel != 100) {
						let wspacing = {
							110: 3,
							120: 1,
							125: 1,
							130: 1,
							140: 1,
							150: 1,
							175: 2,
						};
						let lspacing = {
							120: 1,
							125: 2,
							130: 2,
							140: 3,
							150: 4,
							175: 4,
						};
						$main.find('.cardioVersion__table').each(function() {
							$(this).css({'word-spacing':wspacing[browserZoomLevel]+'px'});
							if(lspacing[browserZoomLevel]) {
								$(this).css({'letter-spacing':lspacing[browserZoomLevel]+'px'});
							}
						});
						$main.find('.cardioVersion__table th, .cardioVersion__table td').each(function() {
							$(this).css({'word-spacing':wspacing[browserZoomLevel]+'px'});
							if(lspacing[browserZoomLevel]) {
								$(this).css({'letter-spacing':lspacing[browserZoomLevel]+'px'});
							}
						});
					}
					$main.find('.cardioVersion__tableWrapper').each(function(i,el) {
						let addHeight = 70;
						if(browserZoomLevel == 80){
							if(i == 0) {
								addHeight = -17;
							} else if(i == 1) {
								addHeight = -15;
							} else {
								addHeight = -3;
							}
							if($.browser.mozilla) {
								if(i == 0) {
									addHeight = -15;
								} else if(i == 1) {
									addHeight = -10;
								} else {
									addHeight = -3;
								}
							}
						}
						if(browserZoomLevel == 90){
							if(i == 0) {
								addHeight = 25;
							} else {
								addHeight = 35;
							}
						}
						if(browserZoomLevel == 109 && $.browser.mozilla) {
							if(i == 0) {
								addHeight = 85;
							} else {
								addHeight = 70;
							}
						}
						if(browserZoomLevel == 120 && $.browser.mozilla) {
							if(i == 0) {
								addHeight = 100;
							} else {
								addHeight = 70;
							}
						}
						if(browserZoomLevel == 125) {
							if(i == 0) {
								addHeight = 85;
							}
							if(i > 0) {
								addHeight = 63;
							}
							if($.browser.mozilla) {
								if(i == 0) {
									addHeight = 105;
								} else {
									addHeight = 52;
								}
							}
						}
						if(browserZoomLevel == 130 && $.browser.mozilla) {
							if(i == 0) {
								addHeight = 110;
							} else {
								addHeight = 75;
							}
						}
						if(browserZoomLevel == 140 && $.browser.mozilla) {
							if(i == 0) {
								addHeight = 120;
							} else {
								addHeight = 80;
							}
						}
						if(browserZoomLevel == 150) {
							if(i == 0) {
								addHeight = 85;
							} else {
								addHeight = 45;
							}
							if($.browser.mozilla) {
								if(i == 0) {
									addHeight = 130;
								} else {
									addHeight = 75;
								}
							}
						}
						if(browserZoomLevel == 175) {
							if(i == 0) {
								addHeight = 120;
							} else {
								addHeight = 65;
							}
						}
						tableSizes.push(this.scrollHeight + addHeight);
					});
				}
			}).then(function(canvas) {
				// window.open(canvas.toDataURL('image/png')); //for debugging only
				var accHeight = 0;
				for(var i = 0; i < tableSizes.length; i++) {
					pdfDoc.addPage();
					var cnvPage = document.createElement('canvas');
					cnvPage.height = tableSizes[i];
					cnvPage.width = 768;
					var ctxPage = cnvPage.getContext('2d');
					ctxPage.drawImage(canvas, 0, accHeight, 768, cnvPage.height, 0, 0, 768, cnvPage.height);
					// window.open(cnvPage.toDataURL('image/png')); //for debugging only

					let scaleWidth = 545;
					let scaledWidth = {
						90: 630,
						80: 700,
					};
					if(browserZoomLevel < 100 && scaledWidth[browserZoomLevel]) {
						scaleWidth = scaledWidth[browserZoomLevel];
					}
					pdfDoc.addImage(cnvPage.toDataURL('image/png'), 'png', 20, -50, scaleWidth,  Math.round(cnvPage.height * 545 / cnvPage.width));
					accHeight += tableSizes[i] - 70;
				}
				callback(pdfDoc);
			});
		}
	}
});
